import { ConnectAccountOnboarding } from "@stripe/react-connect-js";

import { ConnectProvider } from "~/components/stripe/connect-provider";

export function StripeConnectStep({
  organizationId,
  onExit,
}: {
  organizationId: string;
  onExit: () => void;
}) {
  return (
    <div className="bg-background rounded-lg border p-6">
      <div className="mb-4">
        <h2 className="h3 font-heading text-balance">
          Complete Your Account Setup
        </h2>
        <p className="body text-muted-foreground">
          Finish setting up your payment account to start accepting payments.
        </p>
      </div>
      <ConnectProvider organizationId={organizationId}>
        <ConnectAccountOnboarding onExit={onExit} />
      </ConnectProvider>
    </div>
  );
}
